import {
  $AjaxJson
} from '../lf'
import {
  $Urlpath,
  $UrlApipath
} from '../config/config'


export const departmentSearchRequest = {
  GetDepartmentList(func, obj) {
    $AjaxJson($UrlApipath + "Department/GetDepartmentList", obj, function (d) {
      func(d)
    })
  },
}


export const  DepartmentRequest = {

      GetDepartment(func,ID) {
           $AjaxJson($UrlApipath+"Department/GetDepartment",{ID:ID},function (d) {
                func(d)
           })
      },
      AddDepartment(func,obj) {
               $AjaxJson($UrlApipath+"Department/AddDepartment",obj,function (d) {
                    func(d)
               })
      },UpdateDepartment(func,obj) {
               $AjaxJson($UrlApipath+"Department/UpdateDepartment",obj,function (d) {
                    func(d)
               })
      },
      SearchDepartment(func,obj) {
               $AjaxJson($UrlApipath+"Department/GetDepartmentList",obj,function (d) {
                    func(d)
               })
      },
      SetDepartmentStatus(func,ID,Status) {
               $AjaxJson($UrlApipath+"Department/SetDepartmentStatus",{ID:ID,Status:Status},function (d) {
                    func(d)
               })
      },
      SetDepartmentHasChieldren(func,HasChieldren) {
               $AjaxJson($UrlApipath+"Department/SetDepartmentHasChieldren",{HasChieldren:HasChieldren},function (d) {
                    func(d)
               })
      },
      
}






// WEBPACK FOOTER //
// ./src/request/Department.js